import './footer.css';
import FooterColumn from './footer-column';

const Footer = ({ links }) => {
  const col = 12 / links.length;
  return (
    <footer>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="footer-links">
              <div className="row">
                {links.map((columnLinks, key) => <FooterColumn col={col} key={key} link={columnLinks}/>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
